import Core from '../../../Core/Core';
import { IFBFriend } from '../../../SDK/SDKfb';
import { IRewardItem } from '../../../State/reducers/score';
import { createOutlineText, scaleToFit } from '../../../Utils/Utils';
import { ButtonColors, NineSliceButton } from '../../Shared/Buttons/NineSliceButton';
import { HelperFriendPicture } from '../Social/AskFriend/HelperFriendPicture';

export class PlayWithFriendButton extends NineSliceButton {
    private helperFriendPicture: HelperFriendPicture;

    constructor(friend: IFBFriend, item: IRewardItem, width: number, height: number) {
        super(ButtonColors.GREEN, width, height);
        const bg = this;
        this.originalScale.set(scaleToFit(bg.width, bg.height, width, height));
        bg.scale = this.originalScale;
        const avatarWidth = width / 3;
        const helperFriendPicture = (this.helperFriendPicture = new HelperFriendPicture(
            friend,
            avatarWidth,
            this.height * 0.6,
            item
        ));
        helperFriendPicture.x = -this.width / 2 + avatarWidth * 0.6;
        const firstName = friend.name.split(' ')[0];
        const formattedName = Core.local.languageKey === 'tr' ? `${firstName}\n` : `\n${firstName}`;
        const text = `${Core.local.getText('playWith').replace('<friend>', formattedName)}`;
        const txt = createOutlineText(
            text,
            new PIXI.Rectangle(0, 0, bg.width * 2, bg.height * 0.5),
            'Baloo',
            40,
            35,
            0xffffff,
            0x257e0d,
            5
        );
        const scale = scaleToFit(txt.width, txt.height, bg.width * 0.6, bg.height * 0.7);
        txt.scale.set(Math.min(1, scale));
        txt.x = helperFriendPicture.x + avatarWidth * 0.45 + txt.width / 2;
        //@ts-ignore
        this.addChild(txt, helperFriendPicture);
    }

    public cleanUp() {
        super.cleanUp();
        this.helperFriendPicture.destroy();
    }
}
